import { render, staticRenderFns } from "./DisableConfirmation.vue?vue&type=template&id=b9ac5fe2&"
import script from "./DisableConfirmation.vue?vue&type=script&lang=js&"
export * from "./DisableConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports